namespace GeniuzPOS.SalePromoCamp {
    export namespace PsPromoActiveHdService {
        export const baseUrl = 'SalePromoCamp/PsPromoActiveHd';

        export declare function Create(request: Serenity.SaveRequest<PsPromoActiveHdRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsPromoActiveHdRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPromoActiveHdRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPromoActiveHdRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "SalePromoCamp/PsPromoActiveHd/Create",
            Update = "SalePromoCamp/PsPromoActiveHd/Update",
            Delete = "SalePromoCamp/PsPromoActiveHd/Delete",
            Retrieve = "SalePromoCamp/PsPromoActiveHd/Retrieve",
            List = "SalePromoCamp/PsPromoActiveHd/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsPromoActiveHdService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
